// src/components/SidebarMenu/useNaturaOpsVisibility.js
import { useCallback } from 'react'
import { useQuery } from 'react-query'
import { fetchNaturaOpsAllowedWarehouses } from '../../services/naturaOpsServices'
import { userHasPermission } from '../../navigation/NavegationRoutes'

export function useNaturaOpsVisibility(warehouseId, user) {
    const hasPermission = !!(user?.id && userHasPermission(user, 'natura_manaus_poa_ops'))

    const { data: allowedIds } = useQuery(
        'naturaOpsAllowedWarehouses',
        fetchNaturaOpsAllowedWarehouses,
        {
            enabled: hasPermission,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 60,
        }
    )

    return useCallback(() => {
        if (!hasPermission) return false
        if (!warehouseId) return false
        if (!allowedIds) return false
        return allowedIds.includes(parseInt(warehouseId, 10))
    }, [hasPermission, warehouseId, allowedIds])
}
